import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SupportButton from "./components/SupportButton";
import Home from "./pages/Home";
import Bedrijfsoplossingen from "./pages/Bedrijfsoplossingen";
import Diensten from "./pages/Diensten";
import DienstDetail from "./pages/DienstDetail";
import Cloud from "./pages/Cloud";
import Hardware from "./pages/Hardware";
import Jobs from "./pages/Jobs";
import Nieuws from "./pages/Nieuws";
import NieuwsDetail from "./pages/NieuwsDetail";
import Partners from "./pages/Partners";
import Contact from "./pages/Contact";
import Referenties from "./pages/Referenties";
import Privacybeleid from "./pages/Privacybeleid";
import Voorwaarden from "./pages/Voorwaarden";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import CookieConsent from "./components/CookieConsent";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css";

const RECAPTCHA_SITE_KEY = '6LcWVnMsAAAAACY4Wy6hs4hQRoPrg3GXwpO9uyFt';

function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <div className="App min-h-screen text-[#16224b]">
        <BrowserRouter>
          <Routes>
            {/* Admin routes - without main layout */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            
            {/* Public routes - with main layout */}
            <Route path="/*" element={<PublicLayout />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
    </GoogleReCaptchaProvider>
  );
}

function PublicLayout() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/bedrijfsoplossingen" element={<Bedrijfsoplossingen />} />
          <Route path="/diensten" element={<Diensten />} />
          <Route path="/diensten/:slug" element={<DienstDetail />} />
          <Route path="/cloud" element={<Cloud />} />
          <Route path="/hardware" element={<Hardware />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/nieuws" element={<Nieuws />} />
          <Route path="/nieuws/:id" element={<NieuwsDetail />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/referenties" element={<Referenties />} />
          <Route path="/privacy" element={<Privacybeleid />} />
          <Route path="/voorwaarden" element={<Voorwaarden />} />
        </Routes>
      </main>
      <Footer />
      <SupportButton />
      <CookieConsent />
    </>
  );
}

export default App;
